module.exports = __webpack_public_path__ + "img/02_4_5_1.0c14f099.png";